import { Fragment } from 'react';

import { IconCheck } from '@tabler/icons-react';

import styles from './CreatePatientModal.module.scss';

interface StepIndicatorProps {
  steps: string[];
  active: number;
}

/** Compact step bar: small numbered dots, a check once done, thin connecting lines. */
const StepIndicator = ({ steps, active }: StepIndicatorProps) => (
  <ol className={styles.steps} aria-label="Progress">
    {steps.map((label, index) => {
      const state = index < active ? 'done' : index === active ? 'current' : 'todo';
      return (
        <Fragment key={label}>
          {index > 0 && <li aria-hidden className={styles.stepLine} data-done={index <= active} />}
          <li className={styles.step} data-state={state} aria-current={state === 'current'}>
            <span className={styles.stepDot}>
              {state === 'done' ? <IconCheck size={11} stroke={3} /> : index + 1}
            </span>
            <span className={styles.stepLabel}>{label}</span>
          </li>
        </Fragment>
      );
    })}
  </ol>
);

export default StepIndicator;
